export const company = {
  name: 'Magool Tech Solutions',
  shortName: 'Magool Tech',
  tagline: 'The Connection Between Business and Technology',
  slogan: 'We Combine Business and Technology',
  founded: 'June 2021',
  phone: '+252-90-5808077',
  phoneTel: '+252905808077',
  email: 'info@magooltech.com',
  website: 'www.magooltech.com',
  address: 'Global Road, Garowe, Somalia',
  location: 'Garowe, Somalia',
  hours: ['Sat - Thu: 8:00 AM - 6:00 PM', 'Fri: Closed'],
};

export const siteImages = {
  hero: '/images/hero-tech.jpg',
  about: '/images/about-team.jpg',
};

export const aboutText =
  'Magool Tech Solutions is a leading private high technology consulting and ICT firm based in Somalia. We provide software and web development, Odoo ERP, business intelligence, financial advisory, network and security solutions, attendance systems (Hikvision and BioTime), and digital transformation consultancy. Established in June 2021, we help organizations innovate and grow through technology.';

export const vision =
  'To be a leading management consulting and technology services company dedicated to helping organizations innovate, share knowledge, and improve performance through digitalization in Somalia and beyond.';

export const mission =
  'To provide excellent, value-added, and tailored consulting and technology service solutions. Magool Tech Solutions aims to empower government institutions, organizations, and enterprises to deliver innovation and transform their businesses through digitalization.';

export const coreValues = [
  {
    title: 'Integrity',
    description:
      'We uphold the highest ethical standards in all our actions, ensuring honesty, fairness, and transparency in every project and partnership.',
  },
  {
    title: 'Excellence',
    description:
      'We are committed to delivering top-quality services and solutions that exceed client expectations through continuous improvement and attention to detail.',
  },
  {
    title: 'Innovation',
    description:
      'We embrace creativity and emerging technologies to develop cutting-edge ICT and business solutions that drive digital transformation and sustainable growth.',
  },
  {
    title: 'Client-Centric',
    description:
      'Our clients are at the heart of everything we do. We listen, understand, and tailor our services to meet their unique needs with personalized and reliable support.',
  },
];

export const whyChooseUs = [
  {
    title: 'Industry Experts',
    description:
      'Our team brings deep expertise in ICT and technology consulting, delivering solutions backed by years of hands-on experience across Somalia and the region.',
  },
  {
    title: 'Tailored Solutions',
    description:
      'We design value-added services around your business goals — from ERP and financial automation to attendance systems, network infrastructure, and digital transformation.',
  },
  {
    title: 'End-to-End Support',
    description:
      'From strategy and implementation to training and ongoing support, we partner with you at every stage of your technology journey.',
  },
  {
    title: 'Trusted Local Partner',
    description:
      'Based in Garowe, we understand local business needs while delivering world-class consulting and technology services.',
  },
];

export const services = [
  {
    slug: 'odoo-erp-solutions',
    title: 'Odoo ERP Solutions',
    image: '/images/service-odoo.jpg',
    description:
      'Odoo is a comprehensive business management system that helps organizations manage accounting, finance, sales, inventory, HR, and project management — driving digital transformation for your enterprise.',
    features: [
      'Full Odoo Implementation',
      'Accounting & Finance Modules',
      'Sales & Inventory Management',
      'HR & Project Management',
      'Custom Module Development',
      'Training & Support',
    ],
  },
  {
    slug: 'financial-investment-advisory',
    title: 'Financial & Investment Advisory',
    image: '/images/service-finance.jpg',
    description:
      'Strategic financial decision-making support with market insight, investment guidance, and risk management tailored to your organization\'s goals.',
    features: [
      'Financial Planning & Analysis',
      'Investment Strategy',
      'Risk Management',
      'Market Research & Insight',
      'Budget & Forecasting',
      'Compliance Advisory',
    ],
  },
  {
    slug: 'business-intelligence',
    title: 'Business Intelligence',
    image: '/images/service-bi.jpg',
    description:
      'Turn your data into actionable insights with dashboards, analytics tools, and reporting solutions that empower smarter business decisions.',
    features: [
      'Custom Dashboards',
      'Data Visualization',
      'Reporting & Analytics',
      'KPI Tracking',
      'Data Integration',
      'Performance Monitoring',
    ],
  },
  {
    slug: 'network-security-solutions',
    title: 'Network and Security Solutions',
    image: '/images/service-security.jpg',
    description:
      'Integrated network solutions and modern CCTV surveillance systems — designing, implementing, and maintaining secure infrastructure for your organization.',
    features: [
      'Network Design & Setup',
      'Cisco & Mikrotik Solutions',
      'CCTV & Surveillance Systems',
      'Network Security',
      'VPN & Remote Access',
      '24/7 Monitoring',
    ],
  },
  {
    slug: 'attendance-access-control',
    title: 'Attendance & Access Control',
    image: '/images/service-attendance.jpg',
    description:
      'Enterprise time attendance and access control using Hikvision terminals and BioTime software — accurate clock-in/out, shift management, and multi-branch reporting for schools, NGOs, and businesses.',
    features: [
      'Hikvision Time & Attendance Terminals',
      'BioTime Software Setup & Training',
      'Fingerprint & Face Recognition Devices',
      'Shift, Leave & Overtime Management',
      'Multi-Branch Attendance Reports',
      'Payroll & HR System Integration',
    ],
    platforms: ['Hikvision', 'BioTime'],
  },
];
